import { storeToRefs } from "pinia";

import { useBorrowerPlatformTemplateBuilderStore } from "@/stores/borrowerPlatformTemplates";

import type { Block } from "@/models/borrowerPlatformTemplates";
import type { Ref } from "vue";

export const useBlockEdit = (block: Ref<Block>) => {
  const borrowerPlatformTemplateStore =
    useBorrowerPlatformTemplateBuilderStore();
  const { selectedTabId } = storeToRefs(borrowerPlatformTemplateStore);
  const { updateBorrowerPlatformBlock } = borrowerPlatformTemplateStore;

  const updateBlock = <T extends keyof Block>(field: T, value: Block[T]) => {
    if (!selectedTabId.value || !block.value.id) {
      return;
    }

    updateBorrowerPlatformBlock({
      tabId: selectedTabId.value,
      blockId: block.value.id,
      updates: { ...block.value, [field]: value },
    });
  };

  const updateMultipleFields = (updates: Partial<Block>) => {
    if (!selectedTabId.value || !block.value.id) {
      return;
    }

    updateBorrowerPlatformBlock({
      tabId: selectedTabId.value,
      blockId: block.value.id,
      updates: { ...block.value, ...updates },
    });
  };

  return {
    updateBlock,
    updateMultipleFields,
  };
};
